import { bankrCoreSkills } from './skills/bankrCoreSkills';
import { aeonSuiteSkills } from './skills/aeonSuiteSkills';
import { agiprolabsTradingSkills } from './skills/agiprolabsTradingSkills';
import { cryptoskillData } from './skills/cryptoskillData';
import { cryptoskillAiCryptoData } from './skills/cryptoskillAiCrypto';
import { cryptoskillAiCryptoExtraData } from './skills/cryptoskillAiCryptoExtra';
import { cryptoskillExchangesIdentityData } from './skills/cryptoskillExchangesIdentity';
import { cryptoskillAnalyticsExtraAData } from './skills/cryptoskillAnalyticsExtraA';
import { cryptoskillAnalyticsExtraBData } from './skills/cryptoskillAnalyticsExtraB';
import { cryptoskillAnalyticsExtraCData } from './skills/cryptoskillAnalyticsExtraC';
import { cryptoskillChainsExtraData } from './skills/cryptoskillChainsExtra';
import { cryptoskillDefiExtraData } from './skills/cryptoskillDefiExtra';
import { cryptoskillDevToolsExtraData } from './skills/cryptoskillDevToolsExtra';
import { cryptoskillExchangesExtraData } from './skills/cryptoskillExchangesExtra';
import { cryptoskillIdentityExtraData } from './skills/cryptoskillIdentityExtra';
import { cryptoskillMcpServersAData } from './skills/cryptoskillMcpServersA';
import { cryptoskillMcpServersBData } from './skills/cryptoskillMcpServersB';
import { cryptoskillPaymentsAData } from './skills/cryptoskillPaymentsA';
import { cryptoskillPaymentsBData } from './skills/cryptoskillPaymentsB';
import { cryptoskillPredictionMarketsAData } from './skills/cryptoskillPredictionMarketsA';
import { cryptoskillPredictionMarketsBData } from './skills/cryptoskillPredictionMarketsB';
import { cryptoskillSocialData } from './skills/cryptoskillSocial';
import { cryptoskillTradingAData } from './skills/cryptoskillTradingA';
import { cryptoskillTradingBData } from './skills/cryptoskillTradingB';
import { cryptoskillTradingCData } from './skills/cryptoskillTradingC';
import { cryptoskillTradingDData } from './skills/cryptoskillTradingD';
import { cryptoskillWalletsData } from './skills/cryptoskillWallets';

export interface Skill {
  id: string;
  name: string;
  author: string;
  authorHandle: string;
  tag: 'Skill' | 'Plugin';
  category: string;
  description: string;
  downloads: number;
  stars: number;
  version?: string;
  installCommand: string;
  usageExample?: string;
  detailedDescription?: string;
  featured?: boolean;
  trending?: boolean;
}

export const skillCategories = [
  { key: 'all', label: 'All' },
  { key: 'defi', label: 'DeFi & Chains' },
  { key: 'trading', label: 'Trading & Exchanges' },
  { key: 'analytics', label: 'Analytics & Data' },
  { key: 'tools', label: 'Dev Tools & AI' },
  { key: 'social', label: 'Social & Messaging' },
  { key: 'identity', label: 'Identity & Trust' },
  { key: 'wallets', label: 'Wallets & Custody' },
  { key: 'other', label: 'Other' },
];

export const skillsData: Skill[] = [
  ...bankrCoreSkills,
  ...aeonSuiteSkills,
  ...agiprolabsTradingSkills,
  ...cryptoskillData,
  ...cryptoskillAiCryptoData,
  ...cryptoskillAiCryptoExtraData,
  ...cryptoskillExchangesIdentityData,
  ...cryptoskillAnalyticsExtraAData,
  ...cryptoskillAnalyticsExtraBData,
  ...cryptoskillAnalyticsExtraCData,
  ...cryptoskillChainsExtraData,
  ...cryptoskillDefiExtraData,
  ...cryptoskillDevToolsExtraData,
  ...cryptoskillExchangesExtraData,
  ...cryptoskillIdentityExtraData,
  ...cryptoskillMcpServersAData,
  ...cryptoskillMcpServersBData,
  ...cryptoskillPaymentsAData,
  ...cryptoskillPaymentsBData,
  ...cryptoskillPredictionMarketsAData,
  ...cryptoskillPredictionMarketsBData,
  ...cryptoskillSocialData,
  ...cryptoskillTradingAData,
  ...cryptoskillTradingBData,
  ...cryptoskillTradingCData,
  ...cryptoskillTradingDData,
  ...cryptoskillWalletsData,
];

export const skillStats = {
  totalTools: '1584+',
  totalUsers: '118.8k',
  totalDownloads: '46.8M',
  avgRating: '4.8',
};

export const featuredSkills = skillsData.filter((s) => s.featured);
export const trendingSkills = skillsData.filter((s) => s.trending);